import { InvalidControlModel } from '../../cmg-1003/models/validation-panel.model';

export const isRequiredSaveFieldLoanSummary = (controlId: string): boolean => {
  let isRequired = false;
  requiredSaveFieldsLoanSummary.forEach((f) => {
    if (controlId.includes(f)) {
      isRequired = true;
    }
  });
  return isRequired;
};

export const isUnSupportedLoanProgram = (control: InvalidControlModel): boolean => {
  let isUnSupported = false;
  if (control.action === unSupportedError) {
    isUnSupported = true;
  }
  return isUnSupported;
};

export const unSupportedError = 'UnSupported';

export const requiredSaveFieldsLoanSummary = [
  'first',
  'street',
  'last',
  'zipCode',
  'years',
  'months',
  'city',
  'streetforUI',
  'state',
  'dob',
  'ssn',
  'livingStatus',
  'maritalStatus',
  'citizenship',
  'retailLoCompPlan',
  'retailLeadType',
  'leadTypeReason',
];
